import { render, staticRenderFns } from "./userWithdrawal.vue?vue&type=template&id=1962f7dc&scoped=true"
import script from "./userWithdrawal.vue?vue&type=script&lang=js"
export * from "./userWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./userWithdrawal.vue?vue&type=style&index=0&id=1962f7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1962f7dc",
  null
  
)

export default component.exports